import { z } from "zod";
/**
 * Wire contract for `/api/v1/payees` — promoting a free-text expense payee
 * (`expenses.custom_business_name`) to a real business
 * (migration 20261020120000_link_custom_payee.sql).
 */
/** The most names one link may carry (mirrors the RPC's 1..50 check). */
export const LINK_CUSTOM_PAYEE_MAX_NAMES = 50;
/** Longest single name accepted — well above any real `custom_business_name`. */
export const LINK_CUSTOM_PAYEE_MAX_NAME_LENGTH = 500;
/**
 * Body of `POST /api/v1/payees/orgs/:orgId/link`. `names` are the EXACT raw
 * spellings to relink (the view's `variants`, or one expense's raw name) —
 * deliberately NOT trimmed or normalized: the RPC matches them verbatim, so
 * what is relinked is exactly what the user saw listed. A blank entry is
 * refused here and again by the RPC.
 */
export const linkCustomPayeeBodySchema = z
    .object({
    business_id: z.string().uuid(),
    names: z
        .array(z
        .string()
        .max(LINK_CUSTOM_PAYEE_MAX_NAME_LENGTH)
        .refine((s) => s.trim().length > 0, "Name must not be blank"))
        .min(1)
        .max(LINK_CUSTOM_PAYEE_MAX_NAMES),
})
    .strict();
/** Coded error bodies of `POST …/link` (the web reads `err.envelope.code`). */
export const PAYEE_LINK_ERROR_CODES = {
    /** 409: a recurring template with this payee is being generated; retry. */
    busy: "busy",
};
//# sourceMappingURL=payees.js.map